"use client";

import { useEffect } from "react";

/** Registreeri SW ka login-lehel (enne AppShelli). */
export function PwaRegister() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  }, []);
  return null;
}
